import { DeliveryInstructionsPermissions } from "./delivery-instruction-management.orders.permissions";

export class DeliveryInstructionManagementPermissions {
  static DeliveryInstructions = DeliveryInstructionsPermissions?.Permissions;
}

export function getDeliveryInstructionManagementModuleName() {
  return 'WorkflowManagement';
}
